import { render, staticRenderFns } from "./TableJudgesSelView.vue?vue&type=template&id=61499f92"
import script from "./TableJudgesSelView.vue?vue&type=script&lang=js"
export * from "./TableJudgesSelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports